import styled from 'styled-components'
import {Button, Modal} from '@components/lib'

export const TermsModal = styled(Modal)`
  z-index: 1302;
`

export const CheckboxWrapper = styled.div(({theme}) => ({
  display: 'flex',
  marginTop: 20,
  fontSize: theme.fontSizes.small,
  lineHeight: 1.25,
}))

export const CheckboxTexts = styled.div(({theme}) => ({
  marginLeft: '15px',
}))

export const CloseButton = styled(Button)`
  width: auto;
  margin: 20px auto 0;
`
